import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M20.0091 3.50696C20.1371 3.50696 20.2651 3.55596 20.3631 3.65296C20.5581 3.84796 20.5581 4.16496 20.3631 4.35996L15.8201 8.90296H18.1551C18.4311 8.90296 18.6551 9.12696 18.6551 9.40296C18.6551 9.67896 18.4311 9.90296 18.1551 9.90296H14.6131C14.4111 9.90296 14.2281 9.78096 14.1511 9.59396C14.0741 9.40696 14.1171 9.19196 14.2591 9.04896L19.6551 3.65296C19.7531 3.55596 19.8811 3.50696 20.0091 3.50696V3.50696Z"
      fill="currentColor"
    />
    <path
      d="M20.009 3.50696C20.137 3.50696 20.265 3.55596 20.363 3.65296C20.558 3.84796 20.558 4.16496 20.363 4.35996L14.967 9.75596C14.824 9.89896 14.607 9.94196 14.422 9.86396C14.235 9.78696 14.113 9.60396 14.113 9.40196V5.86096C14.113 5.58496 14.337 5.36096 14.613 5.36096C14.889 5.36096 15.113 5.58496 15.113 5.86096V8.19496L19.655 3.65296C19.753 3.55596 19.881 3.50696 20.009 3.50696V3.50696Z"
      fill="currentColor"
    />
    <path
      d="M5.86302 14.09H9.40502C9.60702 14.09 9.79002 14.212 9.86702 14.399C9.94502 14.586 9.90202 14.801 9.75902 14.944L4.36302 20.34C4.16802 20.535 3.85102 20.535 3.65602 20.34C3.46102 20.145 3.46102 19.828 3.65602 19.633L8.19802 15.091H5.86302C5.58702 15.091 5.36302 14.867 5.36302 14.591C5.36302 14.315 5.58602 14.09 5.86302 14.09V14.09Z"
      fill="currentColor"
    />
    <path
      d="M9.40404 14.09C9.46804 14.09 9.53304 14.103 9.59504 14.128C9.78204 14.205 9.90404 14.388 9.90404 14.59V18.132C9.90404 18.408 9.68004 18.632 9.40404 18.632C9.12804 18.632 8.90404 18.408 8.90404 18.132V15.797L4.36204 20.339C4.16704 20.534 3.85004 20.534 3.65504 20.339C3.46004 20.144 3.46004 19.827 3.65504 19.632L9.05104 14.236C9.14604 14.141 9.27404 14.09 9.40404 14.09V14.09Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Shrink');

export default Icon;
